import { blurflower, lotusDarkLogo } from '@/shared/assets';

export function UnsupportedMobilePage() {
  return (
    <div className="dark relative flex min-h-screen w-full items-center justify-center overflow-hidden bg-background px-4 text-foreground">
      <img
        src={blurflower}
        alt=""
        aria-hidden="true"
        className="absolute inset-0 h-full w-full object-cover"
      />

      <main className="relative flex max-w-md flex-col items-center text-center">
        <img src={lotusDarkLogo} alt="Lotus Health" className="mb-8 w-14" />
        <h1 className="text-lg font-semibold tracking-tight">Cortex isn't available on mobile.</h1>
        <p className="mt-3 text-base text-muted-foreground">
          Please switch to a desktop or laptop to continue.
        </p>
      </main>
    </div>
  );
}
